define(function () {
	const GenericCollection = require('civicsBase/generic_collection');
	const ScenarioModel = require('civicsModels/portal/scenario_model');
	const InstrumentModel = require('civicsModels/portal/instrument');
	const ApplicationModel = require('civicsModels/application_model');
	const ViewManager = require('civicsUtils/view_manager');
	const Wizard = require('civicsModels/portal/wizard_model');
	var projectParse = function (data) {
		for (var i = 0; i < data.length; i++) {
			// if this is a project
			if (data[i].applicationType.code.toUpperCase().trim() == ViewManager.globalConfig().get('wizardProjectType').toUpperCase().trim()) {
				data[i].sortDatetime = data[i].addedDateTime;
				data[i].computedDescription = data[i].projectPhaseName.toLowerCase();
			}
			else {
				data[i].sortDatetime = data[i].addedDateTime;
				data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].applicationType.portalDescription, data[i].applicationType.description).toLowerCase();
			}
		}
		return data;
	};

	var parse = function (data) {
		for (var i = 0; i < data.length; i++) {
			data[i].sortDatetime = data[i].addedDateTime;
			data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].applicationType.portalDescription, data[i].applicationType.description).toLowerCase();
		}
		return data;
	};

	var srParse = function (data) {
		for (var i = 0; i < data.length; i++) {
			if (data[i].resolution
				&& data[i].resolution.code
				&& data[i].resolution.code != ''
				&& data[i].resolution.code != ' ') {
				data[i].status = 'Closed';
			} else {
				data[i].status = 'Open';
			}
			data[i].sortDatetime = data[i].applicationDateTime;
			data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].requestType.portalDescription, data[i].requestType.description).toLowerCase();
		}
		return data;
	};

	var instParse = function (data) {
		for (var i = 0; i < data.length; i++) {
			data[i].sortDatetime = data[i].addedDateTime;
			try {
				var el = JSON.parse(data[i].instrumentData);
				data[i].computedDescription = el.applicationDescription.toLowerCase();
			} catch(e){
				data[i].computedDescription = ''.toLowerCase();
			}

			// }
		}
		return data;
	};

	var scenarioParse = function (data) {
		for (var i = 0; i < data.length; i++) {
			data[i].sortDatetime = data[i].addedDateTime;
			data[i].computedDescription = data[i].name.toLowerCase();
		}
		return data;
	};

	var setWizardProperty = function (parent, scenarioId){
		parent.wizard = new Wizard();
		// type can be either scenario driven or config(wizard type) driven
		parent.wizard.type = 'scenarios';
		parent.wizard.typeId = scenarioId;
	};

	return GenericCollection.extend({

		processScenarioProject:function(wizardProjectType,ensureParentProject=true){
			var removeThese = [];
			_.forEach(this.models, el=>{
				if ( this.belongToProject(el)){
					var parent = this.findScenarioProject(el,wizardProjectType);
					if ( !parent && ensureParentProject ){
						//create project that has limited feature
						parent = this.addParentProject(el,wizardProjectType);
					}
					else if ( ensureParentProject ){
						this.validateWizardData(parent,el);
					}
					if( parent )
					{
						if(!parent.get('childInstruments')){
							parent.set({
								childInstruments : []
							});
						}
						parent.get('childInstruments').push(el);
					}

					removeThese.push(el);
				}
			});

			$.each(removeThese,(index,el) => {
				this.remove(el);
			});
		},
		belongToProject:function(childInstrument){
			var belong = false;
			if(childInstrument.get('scenario') && childInstrument.get('scenario.id')>1 ){
				belong = true;
			}
			if(childInstrument.get('ParentProject') && childInstrument.get('ParentProject.id')>1 ){
				belong = true;
			}
			return belong;
		},
		// if the project still contain wizard child , the wizard property has to be set to fetch the wizard data
		validateWizardData:function(parent,childInstrument){
			var scenarioId = childInstrument.get('scenario.id');
			if (  scenarioId &&  scenarioId>1 && !(parent.wizard)){
				setWizardProperty(parent,scenarioId);
			}
		},
		addParentProject:function(childInstrument, wizardProjectType){
			var parent = new ApplicationModel();
			var data;
			var scenarioId;
			if(childInstrument.get('scenario') && childInstrument.get('scenario.id')>1 && childInstrument.get('scenario.application.id')>1){
				data = childInstrument.get('scenario.application').toJSON();
				scenarioId =  childInstrument.get('scenario.id');
			}
			if(childInstrument.get('ParentProject') && childInstrument.get('ParentProject.id')>1 ){
				data = childInstrument.get('ParentProject').toJSON();
			}
			if ( data ) {
				data["_dataType"] = "Project"
				data["_appId"] = "Project|" + data.id;
				data.computedDescription = Handlebars.helpers['global:computedDescription'](data.applicationType.portalDescription, data.applicationType.description).toLowerCase();
				//data.isDummy = true;
				data.applicationType.code= wizardProjectType;
				parent.set(data);
				parent.isDummy = true
				parent.statusChecks = {}
				parent.statusChecks.fetched = true;
				if ( scenarioId ){
					setWizardProperty(parent,scenarioId);
				}
				this.add(parent);
			}
			return parent;
		},
		findScenarioProject:function(childInstrument, wizardProjectType){
			var parent;
			if ( childInstrument ){
				var childProjectId;
				if(childInstrument.get('scenario') && childInstrument.get('scenario.id')>1 && childInstrument.get('scenario.application.id')>1){
					childProjectId = childInstrument.get('scenario.application.id');
				}
				if(childInstrument.get('ParentProject') && childInstrument.get('ParentProject.id')>1 ){
					childProjectId = childInstrument.get('ParentProject.id');
				}
				if ( childProjectId ){
					_.forEach(this.models, el=>{

						if(el.get('_dataType') && el.get('_dataType').toLowerCase()=='project'
							&& el.get('applicationType')
							&& el.get('applicationType.code').toLowerCase() == wizardProjectType.toLowerCase()
							&& el.get('id') == childProjectId
						){
							parent = el;
						}
					});
				}
			}
			return parent;
		},
		dataTypeContext: [{
			collectionParse: parse,
			type: 'Building',
			url: 'cdr/applications/Building',
			select: [
				'id',
				'commonId',
				'applicationName',
				'applicationNumber',
				'applicationtype.code',
				'applicationtype.portalDescription',
				'applicationtype.description',
				'ApplicationContacts.Contact.identity.firstName',
				'ApplicationContacts.Contact.identity.lastName',
				'applicationDateTime',
				'comments',
				'addedDateTime',
				'status',
				'totalFeesCharged',
				'totalUnpaidFees',
				'totalAmountDueNow',
				'totalPortalAmountDueNow'
			]
		}, {
			collectionParse: parse,
			type: 'BusinessLicense',
			url: 'cdr/applications/BusinessLicense',
			select: [
				'id',
				'commonId',
				'BusinessName',
				'applicationNumber',
				'applicationtype.code',
				'applicationtype.portalDescription',
				'applicationtype.description',
				'ApplicationContacts.Contact.identity.firstName',
				'ApplicationContacts.Contact.identity.lastName',
				'applicationDateTime',
				'comments',
				'addedDateTime',
				'status',
				'totalFeesCharged',
				'totalUnpaidFees',
				'totalAmountDueNow',
				'totalPortalAmountDueNow'
			],
			fieldMappings: [{
				appName: 'applicationName',
				svcName: 'BusinessName'
			}, {
				appName: 'Parcel',
				svcName: ''
			}]
		}, {
			collectionParse: parse,
			type: 'CodeEnforcement',
			url: 'cdr/applications/CodeEnforcement',
			select: [
				'id',
				'commonId',
				'CaseName',
				'applicationNumber',
				'applicationtype.code',
				'applicationtype.portalDescription',
				'applicationtype.description',
				'ApplicationContacts.Contact.identity.firstName',
				'ApplicationContacts.Contact.identity.lastName',
				'applicationDateTime',
				'comments',
				'addedDateTime',
				'status',
				'totalFeesCharged',
				'totalUnpaidFees',
				'totalAmountDueNow',
				'totalPortalAmountDueNow'
			],
			fieldMappings: [{
				appName: 'applicationName',
				svcName: 'CaseName'
			}]
		}, {
			collectionParse: parse,
			type: 'Planning',
			url: 'cdr/applications/Planning',
			select: [
				'id',
				'commonId',
				'BusinessName',
				'applicationNumber',
				'applicationtype.code',
				'applicationtype.portalDescription',
				'applicationtype.description',
				'ApplicationContacts.Contact.identity.firstName',
				'ApplicationContacts.Contact.identity.lastName',
				'applicationDateTime',
				'comments',
				'addedDateTime',
				'status',
				'totalFeesCharged',
				'totalUnpaidFees',
				'totalAmountDueNow',
				'totalPortalAmountDueNow'
			],
			fieldMappings: [{
				appName: 'applicationName',
				svcName: 'projectPhaseName'
			}]
		}, {
			collectionParse: projectParse,
			type: 'Project',
			url: 'cdr/applications/Project',
			select: [
				'id',
				'locationLine1',
				'locationLine2',
				'commonId',
				'projectPhaseName',
				'applicationNumber',
				'applicationtype.code',
				'applicationtype.portalDescription',
				'applicationtype.description',
				'ApplicationContacts.Contact.identity.firstName',
				'ApplicationContacts.Contact.identity.lastName',
				'applicationDateTime',
				'comments',
				'addedDateTime',
				'status',
				'totalFeesCharged',
				'totalUnpaidFees',
				'totalAmountDueNow',
				'totalPortalAmountDueNow'
			],
			fieldMappings: [{
				appName: 'applicationName',
				svcName: 'projectPhaseName'
			}]
		}, {
			collectionParse: parse,
			type: 'TradeLicense',
			url: 'cdr/applications/TradeLicense',
			select: [
				'id',
				'commonId',
				'applicationNumber',
				'applicationtype.code',
				'applicationtype.portalDescription',
				'applicationtype.description',
				'ApplicationContacts.Contact.identity.firstName',
				'ApplicationContacts.Contact.identity.lastName',
				'applicationDateTime',
				'comments',
				'addedDateTime',
				'status',
				'totalFeesCharged',
				'totalUnpaidFees',
				'totalAmountDueNow',
				'totalPortalAmountDueNow'
			],
			fieldMappings: [{
				appName: 'Parcel',
				svcName: ''
			}, {
				appName: 'Address',
				svcName: ''
			}]
		}, {
			collectionParse: parse,
			type: 'Use',
			url: 'cdr/applications/Use',
			select: [
				'id',
				'commonId',
				'applicationName',
				'applicationNumber',
				'applicationtype.code',
				'applicationtype.portalDescription',
				'applicationtype.description',
				'ApplicationContacts.Contact.identity.firstName',
				'ApplicationContacts.Contact.identity.lastName',
				'applicationDateTime',
				'comments',
				'addedDateTime',
				'status',
				'totalFeesCharged',
				'totalUnpaidFees',
				'totalAmountDueNow',
				'totalPortalAmountDueNow'
			],
			fieldMappings: [{
				appName: 'applicationName',
				svcName: 'BusinessName'
			}]
		}, {
			// define source data sources
			// - fieldMapping
			// 		appName is the name used by the client
			//  	svcName is the name used by the REST api
			collectionParse: srParse,
			type: 'ServiceRequest',
			url: 'crm/ServiceRequests',
			fieldMappings: [
				{
					appName: 'applicationDateTime',
					svcName: 'requestDate'
				}, {
					appName: 'addedDateTime',
					svcName: 'requestDate',
					type: 'number'
				}, {
					appName: 'applicationNumber',
					svcName: 'id',
					operator: 'Equal',
					type: 'number'
				}, {
					appName: 'ApplicationContacts',
					svcName: ''
				},
				{
					appName: 'applicationType.code',
					svcName: 'requestType.type'
				},
				{
					appName: 'applicationName',
					svcName: ''
				}
			]
		}, {
			// define source data sources
			// - fieldMapping
			// 		appName is the name used by the client
			//  	svcName is the name used by the REST api
			collectionParse: scenarioParse,
			type: 'Scenario',
			url: 'portal/scenarios',
			model: ScenarioModel,
			fieldMappings: [{
				appName: 'applicationNumber',
				svcName: ''
			}, {
				appName: 'applicationType',
				svcName: ''
			}, {
				appName: 'ApplicationContacts',
				svcName: ''
			}, {
				appName: 'Address',
				svcName: ''
			}, {
				appName: 'Parcel',
				svcName: ''
			}, {
				appName: 'applicationName',
				svcName: 'name'
			}],
			select: [
				'id',
				'name',
				'recordId',
				'lastSave',
				'addedDateTime',
				'lastModifiedBy',
				'status',
				'requiredRecordcount',
				'submittedRecordCount',
				'wizardType',
				'application.id',
				'application.commonId',
				'application.applicationNumber',
				'application.applicationType.description',
				'application.applicationType.portalDescription'
			]
		}, {
			// define source data sources
			// - fieldMapping
			// 		appName is the name used by the client
			//  	svcName is the name used by the REST api
			collectionParse: instParse,
			type: 'Instrument',
			url: 'portal/instruments',
			model: InstrumentModel,
			passThroughString:'Type=project',
			fieldMappings: [{
				appName: 'applicationNumber',
				svcName: ''
			},
			{
				appName: 'applicationType.code',
				svcName: 'dataTypeCode'
			},
			 {
				appName: 'ApplicationContacts',
				svcName: ''
			}, {
				appName: 'Address',
				svcName: ''
			}, {
				appName: 'Parcel',
				svcName: ''
			}, {
				appName: 'applicationName',
				svcName: ''
			}],
			select: [
				'id',
				'instrumentData',
				'instrumentType',
				'dataTypeCode',
				'membership',
				'scenario.id',
				'scenario.name',
				'scenario.recordId',
				'scenario.lastSave',
				'addedDateTime',
				'scenario.lastModifiedBy',
				'scenario.status',
				'scenario.wizardType',
				'scenario.application.id',
				'scenario.application.applicationNumber',
				'scenario.application.applicationType.description',
				'scenario.application.applicationType.portalDescription',
				'scenario.application.applicationType.code',
				'scenario.application.projectPhaseName',
				'scenario.application.status',
				'scenario.application.projectPhaseName',
				'scenario.application.applicationDateTime',
				'scenario.application.addedDateTime',
				'scenario.application.comments',
				'scenario.application.location',
				'scenario.application.locaitonLine1',
				'scenario.application.locationLine2',
			]
		}]
	});
});
